import React from 'react';

import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
  FAQ_WHAT_DO_I_GET_WITH_MY_SUBSCRIPTION_ANSWER,
} from 'consts/copy';

import type { FaqProps } from '..';

export const FAQ_NEUTRAL_CONTENT: FaqProps = {
  header: 'FAQs',
  faqs: [
    {
      question: 'Who are our dermatology providers?',
      answer: (
        <React.Fragment>
          <p>
            Every Curology member is matched with a board-certified
            dermatologist, physician assistant, or nurse practitioner licensed
            in their home state. Your provider sticks by you throughout your
            journey to check in on your progress, answer any questions, and make
            changes to your formula as needed.
          </p>
          <p>
            Curology’s physicians are graduates of leading medical schools and
            have completed dermatology residencies accredited by the American
            Board of Dermatology. Our physician assistants and nurse
            practitioners have trained extensively in dermatology and work
            closely alongside our dermatologists.
          </p>
        </React.Fragment>
      ),
    },
    {
      question: 'What do I get with my subscription?',
      answer: FAQ_WHAT_DO_I_GET_WITH_MY_SUBSCRIPTION_ANSWER,
    },
    {
      question: 'Will Curology irritate sensitive or dry skin?',
      answer:
        'Your Curology formula is created for your unique skin type. Just let your provider know if you have sensitive or dry skin, and they will make sure your formula is the right strength for your skin. If you do happen to experience irritation, we can always explore a gentler formula.',
    },
    {
      question: 'What if Curology doesn’t work for me?',
      answer: (
        <React.Fragment>
          <p>
            Your personal dermatology provider is here to help you achieve your
            skin goals. If you’re not seeing progress with your first formula,
            your provider can tweak it until you’re happy with your results.
          </p>
        </React.Fragment>
      ),
    },
  ],
  ctaButton: {
    buttonText: CTA_UNLOCK_YOUR_OFFER,
    disclaimerText: DISCLAIMER_CONSULTATION_CANCEL,
  },
};
